module.exports = __webpack_public_path__ + "img/tab05.47751e30.jpg";